import BaseProxy from "../../../base-proxy";

/**
 * @class AddNewShareholderProxy
 * @description AddNewShareholderProxy
 * @author Edmark Santos
 * @version 1.0
 * @since July 22, 2020
 */
export default {
  /**
   * @async
   * @function startAdditionOfShareholder
   * @param input Input parameter.
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async startAdditionOfShareholder(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/workflow/api/tasks/additionofnewshareholder/start`;

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },

  /**
   * @async
   * @function updateAdditionOfShareholder
   * @param input Input parameter.
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async updateAdditionOfShareholder(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/workflow/api/tasks/additionofnewshareholder/${input.processId}/${input.taskName}/${input.taskId}`;

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },

  /**
   * @async
   * @function saveDetails
   * @param input Input parameter.
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async saveDetails(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/workflow/api/tasks/additionofnewshareholder/save-details`;

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },

  /**
   * @async
   * @function saveShares
   * @param input Input parameter.
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async saveShares(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/workflow/api/tasks/additionofnewshareholder/save-shares`;

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },

  /**
   * @async
   * @function saveAttachments
   * @param input Input parameter.
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async saveAttachments(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/workflow/api/tasks/additionofnewshareholder/save-attachments`;

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },
};
